import React from 'react'

const LegalInfo = ({ data }) => {

    return (
        <div className='p-4 rounded-lg m-2 bg-[#F3F3F3]'>
            <div className="mt-4">
                <h3 className="font-medium text-[#0B0910CC]/80 outfit400">Legal entity</h3>
                <p className="text-[#0B0910] outfit500 text-wrap break-words">{data?.name || "-"}</p>
                <p className="text-[#0B0910] outfit500 text-wrap break-words">{data?.evmWalletAddress || '-'}</p>
                <p className="text-[#0B0910] outfit500  text-wrap break-words">{data?.description || "-"}</p>
                <p className="text-[#0B0910] outfit500 text-wrap break-words">{data?.taxId || '-'}</p>
                <p className="text-[#0B0910] outfit500  text-wrap break-words">{data?.website || '-'}</p>
            </div>
        </div>
    )
}

export default LegalInfo